import React, { forwardRef } from 'react'
import cn from 'classnames'
import MatrixMessagePanel from 'matrix-react-sdk/lib/components/structures/MessagePanel'
import { isMessengerRoom } from 'ducks/chat/utils/messenger'

const continuedTypes = ['m.room.message']

const MessagePanel = forwardRef((props, ref) => {
  const { room } = props
  return (
    <MatrixMessagePanel
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      ref={ref}
      continuedTypes={continuedTypes}
      className={cn(props.className, {
        mx_ReactionsDisabled: isMessengerRoom(room),
      })}
    />
  )
})

export default MessagePanel
